import { CmsApplianceDetailsSteppedPage } from '../../models/appliance-details-stepped/cms-appliance-details-stepped-page.interface';
import { mockCmsApplianceDetailsSteppedBenefitsPanel } from '../appliance-details-stepped-benefits-panel/cms-appliance-details-stepped-benefits-panel.mock';
import { mockCmsRegistrationRoot } from '../cms/cms-registration-root.mock';
import { mockCmsProtectionUpsellPanel } from '../protection-upsell/cms-protection-upsell-panel.mock';
import { mockCmsApplianceDetailsSteppedForm } from './cms-appliance-details-stepped-form.mock';

export const mockCmsApplianceDetailsSteppedPage: CmsApplianceDetailsSteppedPage =
  {
    ...mockCmsRegistrationRoot,
    ...mockCmsApplianceDetailsSteppedForm,
    ...mockCmsProtectionUpsellPanel,
    applianceDetailsSteppedBenefitsPanel:
      mockCmsApplianceDetailsSteppedBenefitsPanel,
    pagePanel: 'Page panel',
  };
